
import React from "react";
import { SidebarHeader as Header } from "@/components/ui/sidebar";

const fullLogoPath = "/brand-assets/6c2571e5-9098-4491-affb-a77c3ebc534c.png";

export const SidebarHeader: React.FC = () => {
  return (
    <Header
      className="relative flex items-center justify-center overflow-hidden border-b border-sidebar-border bg-sidebar px-6 py-7"
      data-onboarding="header-logo"
    >
      <div className="absolute inset-x-6 bottom-0 h-px bg-sidebar-ring/30" aria-hidden="true" />
      <div className="absolute inset-x-6 top-0 h-px bg-sidebar-foreground/10" aria-hidden="true" />
      <div className="relative flex w-full items-center justify-center px-5 py-3">
        <span
          aria-label="ComuniHome"
          role="img"
          className="block h-[60px] w-full max-w-[220px] scale-[1.2] bg-white"
          style={{
            WebkitMaskImage: `url(${fullLogoPath})`,
            WebkitMaskPosition: "center",
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskSize: "contain",
            maskImage: `url(${fullLogoPath})`,
            maskPosition: "center",
            maskRepeat: "no-repeat",
            maskSize: "contain",
          }}
        />
      </div>
    </Header>
  );
};
